import { createContext } from "react";

const AcuerdosContext = createContext();

export default AcuerdosContext;
